
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"22","viewBox":"0 0 17 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.23 16.5c-2.4-1.7-6.78-5.53-6.78-9.22 0-2.42 1.29-4.66 3.39-5.87a6.785 6.785 0 016.78 0 6.774 6.774 0 013.39 5.87c0 3.69-4.38 7.53-6.78 9.22z","stroke":"#B69E64","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8.23 9a1.81 1.81 0 100-3.62 1.81 1.81 0 000 3.62z","stroke":"#1D1D1B","stroke-miterlimit":"10","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M13.41 16.94c1.57.39 2.55.94 2.55 1.56 0 1.16-3.46 2.1-7.73 2.1-4.27 0-7.73-.94-7.73-2.1 0-.62.99-1.18 2.56-1.56","stroke":"#B69E64","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    